// extracted by mini-css-extract-plugin
export default {"signPage":"signPage_signPage__Mw6nI","tab":"signPage_tab__bePTf"};